import client from "./base"
import { cheapestProductModel } from "./../models/cheapest-product"

export type IgetCheapestPriceProduct = {
    offset?: number,
    limit?: number,
    skip?: number,
    where?: {
        additionalProp1: string,
    }
}


export const getCheapestPriceProduct = async (filter: IgetCheapestPriceProduct, query: string = '') => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pharmacy-product-price-tracks/list?filter=${JSON.stringify(filter)}`;
    if (query) path += `&query=${query}`;
    return await client.get<cheapestProductModel[]>(path).then(res => res.data);
}

export const getProductPriceTrack = async (mProductId: string) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pharmacy-product-price-tracks?mProductId=${mProductId}`
    return await client.get(path)
}

export const getProductDropshipingTrackByAdmin = async (mPharmacyId:string, mProductId: string) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/track-dropshipping-mapping-by-admin?mProductId=${mProductId}&mPharmacyId=${mPharmacyId}`
    return await client.get(path)
}

export const getProductDropshipingTrack = async (mProductId: string) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pharmacy-product-dropshipping-tracks?mProductId=${mProductId}`
    return await client.get(path)
}

export const createProductPriceTrack = async (mProductId: string) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pharmacy-product-price-tracks`
    return await client.post(path, { mProductId })
}

export const createProductDropshippingTrackByAdmin = async (mPharmacyId: number, mProductId: string, mDropshippingPharIds?: number[]) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/create-dropshipping-mapping-by-admin`
    return await client.post(path, [{ mPharmacyId, mProductId, mDropshippingPharIds }])
}

export const createProductDropshippingTrack = async (mProductId: string, mDropshippingPharIds?: number[]) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pharmacy-product-dropshipping-tracks`
    return await client.post(path, { mProductId, mDropshippingPharIds })
}

export const updateProductDropshippingTrack = async (mProductId: string, mDropshippingPharIds?: number[]) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pharmacy-product-dropshipping-tracks`
    return await client.put(path, { mProductId, mDropshippingPharIds })
}

export const updateProductDropshippingTrackByAdmin = async (mPharmacyId: number, mProductId: string, mDropshippingPharIds?: number[]) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/update-dropshipping-mapping-by-admin`
    return await client.put(path, [{ mPharmacyId, mProductId, mDropshippingPharIds }])
}

export const getCountUnread = async () => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pharmacy-product-price-tracks/count-unread`
    return await client.get(path)
}

export const readAll = async () => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pharmacy-product-price-tracks/read-all`
    return await client.patch(path)
}

export const total = async (query: string = '') => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pharmacy-product-price-tracks/count`
    if (query) path += `?query=${query}`;
    return await client.get(path)
}

export const getDropshippingPharmacy = async () => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/get-dropshipping-pharmacy`
    return await client.get(path)
}

export const getDropshippingPharmacyByAdmin = async () => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/get-dropshipping-pharmacy-by-admin`
    return await client.get(path)
}